var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.notification ? _c('div', {
    staticClass: "board-container",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip', {
    staticClass: "font-weight-extrabold",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "secondary"
    }
  }, [_c('v-icon', {
    staticClass: "font-size-14 mr-4px",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v(_vm._s(_vm.notification.category))])], 1)], 1), _c('v-col', [_c('h5', {
    staticClass: "tit tit--xxs"
  }, [_vm._v(_vm._s(_vm.notification.subject))])])], 1), _c('table', {
    staticClass: "board-view mt-12px mt-md-20px"
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("작성일 : " + _vm._s(_vm.notification.createdAt.toDate()))])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-view mr-4px"
  }), _vm._v(" " + _vm._s(_vm.notification.viewCount) + " ")])], 1)], 1)], 1)]), _vm.notification.uploads ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('span', {
    staticClass: "mr-10px"
  }, [_vm._v("첨부파일")]), _c('v-row', {
    staticClass: "row--xxs"
  }, _vm._l(_vm.notification.uploads, function (upload, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      staticClass: "grey--text",
      attrs: {
        "x-small": "",
        "color": "grey lighten-5"
      },
      on: {
        "click": function click($event) {
          return _vm.download(upload.src, upload.name);
        }
      }
    }, [_vm._v(" " + _vm._s(upload.name.split('/').pop()) + " ")])], 1);
  }), 1)], 1)], 1)]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "content_box",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.notification.content.replace(/\n/g, '<br>'))
    }
  })])])]), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "board-view-navi"
  }, [_vm._m(0), _vm._m(1)]), _c('v-layout', {
    staticClass: "mt--md",
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "grey lighten-3"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("리스트")])])], 1), _c('div', {
    staticClass: "mt-20 mt-md-30"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "v-btn--group justify-end"
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    }
  }, [_vm._v("수정")]), _c('v-btn', {
    attrs: {
      "large": "",
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v("삭제")]), _c('v-btn', {
    staticClass: "grey-2--text",
    attrs: {
      "large": "",
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v("답글")])], 1)])], 1) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("이전글")]), _c('td', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("이전 게시글 제목입니다.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("다음글")]), _c('td', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("다음 게시글 제목입니다.")])])]);
}]

export { render, staticRenderFns }